import "./sidebar.css";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { unregisterDeviceToken } from "../../services/push.service";

const FrozenSidebar = () => {
  const { sellerPic, sellerMeData } = useSelector((state) => state.vendorDetailsReducer);
  // Remove actionReducer since we don't need dynamic counts for frozen sidebar
  
  const [openSubMenu, setOpenSubMenu] = useState(null);
  const [sellerDetail, setSellerDetails] = useState("");
  
  // All menus are disabled except profile/logout
  const isMenuDisabled = () => true;

  useEffect(() => {
    if (sellerMeData) {
      setSellerDetails(sellerMeData);
    }
  }, [sellerMeData]);

  const handleMenuClick = (e, menu) => {
    e.preventDefault();
    e.stopPropagation();
    console.warn("🚫 Menu disabled:", menu.label);
    return false;
  };

  // Real logout function - same as original sidebar
  async function logout() {
    try {
      await unregisterDeviceToken()
    }
    catch (err) {
      console.warn("Error during unregisterDeviceToken on logout:", err);
    } finally {
      localStorage.clear();
      window.location.assign("/");
    }
  }

  function toggleSidebar(data) {
    console.log("Toggle sidebar:", data);
  }

  const topMenus = [
    {
      label: "Notices",
      link: "/brand-notice",
      icon: "add-bell.png",
      show: true,
      new: false,
      // Remove countShow to avoid loader
      subMenus: [],
    },
    {
      label: "Support",
      link: "/seller-support",
      icon: "support.webp",
      show: true,
      new: false,
      subMenus: [],
    },
  ];

  const menus = [
    {
      label: "Home",
      link: "/home",
      icon: "home.webp",
      show: true,
      new: false,
      subMenus: [],
    },
    {
      label: "Brands",
      icon: "brand.webp",
      link: "/my-brands",
      show: true,
      new: true,
      subMenus: [
        { label: "My Brands", link: "/my-brands", show: true },
        { label: "Add New Brand", link: "/apply-brand", show: true },
        { label: "Transactions", link: "/brand/transaction", show: true }
      ],
    },
    {
      label: "Opportunities",
      icon: "payment.webp",
      link: "/opportunities/outofstock-opportunities",
      show: true,
      new: false,
      // Remove countShow to avoid loader
      subMenus: [
        { label: "Product opportunities", link: "/opportunities/product-opportunities", show: true, },
        { label: "Re-stock opportunities", link: "/opportunities/outofstock-opportunities", show: true },
        { label: "Pricing opportunities", link: "/opportunities/pricing-opportunities", show: true }
      ],
    },
    {
      label: "Enquiries",
      link: "/my-enquiry",
      icon: "enquiry.webp",
      show: true,
      new: false,
      subMenus: [],
    },
    {
      label: "Add New Product",
      link: "/products",
      icon: "order.webp",
      show: true,
      new: false,
      // Remove countShow to avoid loader
      subMenus: [
        { label: "Simple Product", link: "/form", show: true },
        { label: "Bulk Upload", link: "/bulk-upload", show: true },
        { label: "Choose from Catalogue", link: "/add-Product", show: true },
        { label: "Drafts", link: "/my-inventory/new_product_request/drafted", show: true },
        { label: "Action Required", link: "/my-inventory/new_product_request/action_req", show: true }
      ],
    },
    {
      label: "Leads",
      icon: "question.webp",
      show: true,
      link: "/customer-leads/details",
      // Remove countShow to avoid loader
      new: false,
      subMenus: [],
    },
    {
      label: "Orders",
      link: "/my-order/unprocessed",
      icon: "order.webp",
      show: true,
      new: false,
      // Remove countShow to avoid loader
      subMenus: [
        { label: "Grab order", link: "/my-order/graborder", show: true },
        { label: "New orders", link: "/my-order/unprocessed", show: true },
        { label: "Support Redispatch", link: "/my-order/redispatch", show: true },
        { label: "Ready to Ship", link: "/my-order/processed", show: true },
        { label: "Shipped", link: "/my-order/inTransit", show: true },
        { label: "Cancelled", link: "/my-order/cancelled", show: true },
        { label: "Revoked", link: "/my-order/revoke", show: true },
        { label: "Delivered", link: "/my-order/delivered", show: true },
        { label: "All Orders", link: "/my-order/allOrders", show: true },
      ],
    },
    {
      label: "Returns",
      link: "/my-order/rto/in_transit",
      icon: "rto.webp",
      show: true,
      new: false,
      subMenus: [
        { label: "In-Transit", link: "/my-order/rto/in_transit", show: true },
        { label: "Delivered", link: "/my-order/rto/delivered", show: true },
      ],
    },
    {
      label: "Products",
      icon: "inventory.webp",
      link: "/my-inventory/approved",
      show: true,
      new: false,
      showBadge: true,
      subMenus: [
        { label: "Active Products", link: "/my-inventory/approved/active", show: true },
        {
          label: "Out of Stock",
          link: "/my-inventory/approved/outofstock",
          show: true,
        },
        {
          label: "Price Verification Pending",
          link: "/my-inventory/new_offer_price",
          show: true,
        },
        {
          label: "Action Required",
          link: "/my-inventory/approved/actionrequired",
          show: true,
        },
        {
          label: "Weight Verification",
          link: "/my-inventory/approved/weightverification",
          show: true,
        },
      ],
    },
    {
      label: "Reviews",
      icon: "brand.webp",
      link: "/customerReviews",
      show: true,
      new: false,
      subMenus: [],
    },
    {
      label: "Customer Support",
      icon: "brand.webp",
      link: "/support",
      show: true,
      // Remove count to avoid loader
      new: true,
      subMenus: [],
    },
    {
      label: "Q & A",
      icon: "question.webp",
      show: true,
      link: "/questions/pending",
      new: false,
      // Remove count to avoid loader
      subMenus: [],
    },
    {
      label: "Report",
      icon: "report.webp",
      link: "/payment/my-transactions",
      show: true,
      new: false,
      subMenus: [
        { label: "Orders", link: "/payment/my-transactions", show: true },
        { label: "Leads", link: "/wallet-transaction", show: true },
      ],
    },
    {
      label: "Payment",
      icon: "payment.webp",
      link: "/payment/settlements/completed",
      show: true,
      new: false,
      subMenus: [
        { label: "Completed", link: "/payment/settlements/completed", show: true },
        { label: "Onhold", link: "/payment/settlements/onhold", show: true },
        { label: "Deduction", link: "/payment/settlements/deduction", show: true },
        { label: "Penalty", link: "/payment/settlements/penalty", show: true }
      ],
    },
    {
      label: "FAQ's",
      icon: "faq.webp",
      link: "/faq/faq-tcs",
      show: true,
      new: false,
      subMenus: [
        { label: "FAQ's for TCS", link: "/faq/faq-tcs", show: true },
        { label: "FAQ's for TDS", link: "/faq/faq-tds", show: true },
        { label: "FAQ for Form 16A", link: "/faq/faq-form16", show: true },
      ],
    },
  ];

  return (
    <>
      <div className="back-drob d-none d-lg-block" style={{ position: "fixed" }} onClick={() => toggleSidebar(false)}>
        <div className="cross-menu" onClick={() => toggleSidebar(false)}>x</div>
      </div>
      <div className="sidebar d-none d-lg-block frozen-sidebar" style={{ 
        height: '100vh', 
        overflowY: 'auto', 
        overflowX: 'hidden',
        position: 'fixed',
        top: 0,
        left: 0,
        width: '250px',
        zIndex: 1000
      }}>
        {/* Frozen indicator */}
        <div 
          className="frozen-indicator" 
          style={{
            color: 'white',
            padding: '8px 12px',
            borderRadius: '6px',
            fontSize: '12px',
            fontWeight: 'bold',
            textAlign: 'center',
            boxShadow: '0 2px 8px rgba(255, 107, 107, 0.3)',
            background: 'linear-gradient(135deg, #ff6b6b, #ee5a24)',
            flexShrink: 0
          }}
        >
          🚫 Your Account Frozen
          <div style={{ fontSize: '10px', marginTop: '4px', opacity: 0.9 }}>
            All menu items are disabled.
          </div>
        </div>
        
        {/* Profile Section - Same structure as original */}
        <ul className="nav flex-column" style={{ borderBottom: '1px solid #eee', marginBottom: '10px' }}>
          <li className={`nav-item border-bottom ${openSubMenu === 'profile' ? "active" : ""}`}>
            <div
              onClick={() => setOpenSubMenu(openSubMenu === 'profile' ? null : 'profile')}
              className={`nav-link ${openSubMenu === 'profile' ? "active" : ""}`}
              style={{ cursor: "pointer", display: 'flex', alignItems: 'center' }}
            >
              {sellerPic === "" ? (
                <div 
                  className="icon" 
                  style={{ 
                    width: '32px', 
                    height: '32px', 
                    borderRadius: '50%', 
                    backgroundColor: '#007bff', 
                    color: 'white', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center', 
                    fontSize: '14px',
                    fontWeight: 'bold',
                    marginRight: '12px'
                  }}
                >
                  {sellerDetail?.name && sellerDetail?.name[0]}
                </div>
              ) : (
                <img
                  src={"https://s3.toolsvilla.com/mob/avatar/" + sellerPic}
                  className="menu-icon"
                  alt="user"
                  style={{ 
                    width: '32px', 
                    height: '32px', 
                    borderRadius: '50%', 
                    objectFit: 'cover',
                    marginRight: '12px'
                  }}
                />
              )}
              <div className="main-menu-label" style={{ flex: 1 }}>
                {sellerDetail?.name || "Loading..."}
                <div className="badge-container">
                  <img
                    src="/menu-icon/right-arrow.png"
                    className={`right-menu-icon ${openSubMenu === 'profile' ? "rotate-icon" : ""}`}
                    alt="arrow"
                  />
                </div>
              </div>
            </div>
            <ul className={`nav flex-column submenu ${openSubMenu === 'profile' ? "show" : ""}`}>
              <li className="nav-item">
                <div
                  className="nav-link submenu-item"
                  style={{ cursor: "pointer" }}
                  onClick={logout}
                >
                  <div>Logout</div>
                </div>
              </li>
            </ul>
          </li>
        </ul>
        
        <div className="main-menu">
          <ul className="nav flex-column">
            {/* Top menu items */}
            <div className="d-flex">
              {topMenus.map((menu, index) => (
                menu.show && <li
                  className={`nav-item border-bottom flex-fill ${openSubMenu === menu.label + index ? "active" : ""}`}
                  key={index}
                >
                  <div
                    onClick={(e) => handleMenuClick(e, menu)}
                    className={`nav-link ${openSubMenu === menu.label + index ? "active" : ""} disabled-menu-item`}
                    style={{ 
                      cursor: "not-allowed", 
                      opacity: 0.4,
                      pointerEvents: "none"
                    }}
                    title="Account frozen - feature unavailable"
                  >
                    <img
                      src={"/menu-icon/" + menu.icon}
                      className="menu-icon"
                      alt="icon"
                    />
                    {menu.label}
                    {/* Removed loader logic */}
                  </div>
                </li>
              ))}
            </div>

            {/* Main menu items */}
            {menus.map((menu, index) => (
              menu.show && <li
                className={`nav-item border-bottom ${openSubMenu === menu.label + index ? "active" : ""}`}
                key={index + 2}
              >
                {menu.subMenus.length === 0 ? (
                  <div
                    onClick={(e) => handleMenuClick(e, menu)}
                    className={`nav-link ${openSubMenu === menu.label + index ? "active" : ""} disabled-menu-item`}
                    style={{ 
                      cursor: "not-allowed", 
                      opacity: 0.4,
                      pointerEvents: "none"
                    }}
                    title="Account frozen - feature unavailable"
                  >
                    <img
                      src={"/menu-icon/" + menu.icon}
                      className="menu-icon"
                      alt="icon"
                    />
                    {menu.label}
                    {/* Removed loader logic */}
                  </div>
                ) : (
                  <div
                    onClick={(e) => handleMenuClick(e, menu)}
                    className={`nav-link ${openSubMenu === menu.label + index ? "active" : ""} disabled-menu-item`}
                    style={{ 
                      cursor: "not-allowed", 
                      opacity: 0.4,
                      pointerEvents: "none"
                    }}
                    title="Account frozen - feature unavailable"
                  >
                    <img
                      src={"/menu-icon/" + menu.icon}
                      className="menu-icon"
                      alt="icon"
                    />
                    <div className="main-menu-label">
                      {menu.label}
                      <div className="badge-container">
                        {/* Removed loader logic completely */}
                        <img
                          src="/menu-icon/right-arrow.png"
                          className={`right-menu-icon ${openSubMenu === menu.label + index ? "rotate-icon" : ""}`}
                          alt="arrow"
                        />
                      </div>
                    </div>
                  </div>
                )}
                <ul
                  className={`nav flex-column submenu ${openSubMenu === menu.label + index ? "show" : ""}`}
                >
                  {menu.subMenus.map((subMenu, subIndex) => (
                    subMenu.show && <li className="nav-item" key={subIndex}>
                      <div 
                        className={`nav-link submenu-item space-between disabled-menu-item`}
                        onClick={(e) => handleMenuClick(e, subMenu)}
                        style={{ 
                          cursor: "not-allowed", 
                          opacity: 0.4,
                          pointerEvents: "none"
                        }}
                        title="Account frozen - feature unavailable"
                      >
                        <div>{subMenu.label}</div>
                        {/* Removed all loader/count logic from submenus */}
                      </div>
                    </li>
                  ))}
                </ul>
              </li>
            ))}
          </ul>
        </div>
        
        <ul className="nav flex-column bottom-menu">
          <li className="nav-item border-bottom">
            <img
              src="/menu-icon/seller-logo.webp"
              alt="LOGO"
              className="sidebar-logo img-fluid"
            />
          </li>
        </ul>
      </div>
    </>
  );
};

export default FrozenSidebar;